import { render } from "./capaForm.vue?vue&type=template&id=1fdb77a4"
import script from "./capaForm.vue?vue&type=script&lang=js"
export * from "./capaForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__